export var TwainGameId;
(function (TwainGameId) {
    TwainGameId[TwainGameId["B_RING"] = 19] = "B_RING";
    TwainGameId[TwainGameId["T_KICK"] = 20] = "T_KICK";
    TwainGameId[TwainGameId["RNG_T_KICK"] = 24] = "RNG_T_KICK";
    TwainGameId[TwainGameId["RNG_B_RING"] = 25] = "RNG_B_RING";
})(TwainGameId || (TwainGameId = {}));
